<ape-modal
  [visible]="isOpen"
  [title]="TRANSLATION_KEYS.admin.calibrationTalentMatrix.CONFIRM_AND_SEND_TITLE | translate"
  (onClose)="onClose()"
  [dismissableMask]="false"
  [showSecondaryButton]="true"
  [secondaryActionLabel]="TRANSLATION_KEYS.generic.CANCEL | translate"
  [primaryActionLabel]="TRANSLATION_KEYS.admin.calibrationTalentMatrix.CONFIRM_AND_SEND | translate"
  (onCancel)="onCancel()"
  (onConfirm)="onConfirm()"
>
  <!-- Contenuto della modale -->
  <div class="space-y-4">
    <!-- Testo principale -->
    <p>
      {{ TRANSLATION_KEYS.admin.calibrationTalentMatrix.CONFIRM_AND_SEND_DESCRIPTION | translate }}
    </p>

    <!-- Riepilogo -->
    <div class="mt-4">
      <p class="font-medium mb-2">
        {{ TRANSLATION_KEYS.admin.calibrationTalentMatrix.SUMMARY | translate }}
      </p>
      <ul class="list-disc ml-6 space-y-1 mt-2">
        <li *ngFor="let personSummary of summary; trackBy: trackByPersonId">
          {{ getPersonFullName(personSummary.person) }} - {{ personSummary.currentQuadrant.level }}
          <span *ngIf="personSummary.hasBeenMoved">
            - <span class="font-medium">{{ TRANSLATION_KEYS.admin.calibrationTalentMatrix.MOVED_TO_CALIBRATION |
              translate }}</span>
          </span>
        </li>
      </ul>
    </div>

    <!-- Avviso finale -->
    <p class="font-medium">
      {{ TRANSLATION_KEYS.admin.calibrationTalentMatrix.CONFIRM_AND_SEND_WARNING | translate }}
    </p>
  </div>
</ape-modal>